import React, { useContext, useEffect, useState } from "react";
import * as Component from "../../../component";
import * as Style from "../../../component/style/content/default";
import * as Services from "../../../service";
import * as Modal from "./modal";
import { Method } from "../../../service";
import { Numeric, displayStatus, Moment } from "../../../util";
import Select from "react-select";
import api_permission from "service/api/permission";
import moment from "moment";
import Datepicker from "react-datepicker";

const data_more = [
  { name: "Lihat Detail", status: 'all', permission: 'staff' },
  { name: "Ubah", status: '', permission: 'staff' },
  { name: "Approve", status: '', permission: 'owner' },
  { name: "Reject", status: '', permission: 'owner' }
];

const statusList = [
  { value: '', label: 'Semua Status' },
  { value: '0', label: 'Pending' },
  { value: '3', label: 'Approved' },
  { value: '4', label: 'Reject' }
]

const typeList = [
  { value: 'TRANSFER_STOCK', label: 'TRANSFER_STOCK' },
  { value: 'DIRECT_STOCK', label: 'DIRECT_STOCK' }
]

export default function RequestStock() {
  const { selected_company, dispatch, retail_permission, data_user } = useContext(Services.Context);
  const [modal, setModal] = useState({
    company: false,
  });
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    data: [],
    page: 1,
    lastPage: 1,
  });
  const [statusSelected, setStatusSelected] = useState({ value: '', label: 'Semua Status' });
  const [typeSelected, setTypeSelected] = useState("");
  const [modalDetail, setModalDetail] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const [modalForm, setModalForm] = useState(null);
  const [detailData, setDetailData] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [storeTo, setStoreTo] = useState([]);
  const [storeToSelected, setStoreToSelected] = useState("");
  const [storeFrom, setStoreFrom] = useState([]);
  const [storeFromSelected, setStoreFromSelected] = useState("");
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleCheck = (item) => {
    const exists = selectedItems.find((i) => i.stock_id === item.stock_id);
    if (exists) {
      setSelectedItems(selectedItems.filter((i) => i.stock_id !== item.stock_id));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const handleCheckAll = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else {
      setSelectedItems(data.data);
    }
    setSelectAll(!selectAll);
  };

  const header = [];

  if (statusSelected.label === "Pending") {
    header.push(
      <input
        type="checkbox"
        checked={selectAll}
        onChange={handleCheckAll}
      />
    );
  }

  header.push(
    "No",
    "Produk",
    "Tipe",
    "Dari",
    "Ke",
    "Qty",
    "Untuk Tanggal",
    "Foto",
    "Status",
    "Aksi"
  );

  useEffect(() => {
    if (selected_company.value) {
      api_permission(dispatch, selected_company.value, data_user.id)
    }
  }, [selected_company])

  const GetCompany = async () => {
    await Method.get(`company`)
      .then(async (res) => {
        if (res?.data?.success) {
          if (!selected_company.value) {
            dispatch({
              type: "SELECTED_COMPANY",
              selected_company: {
                value: res?.data?.data[0]?.company_id,
                label: res?.data?.data[0]?.company_name,
              },
            });
          }
        } else {
          Component.AlertError({ title: "Error", text: res?.data?.error });
        }
      })
      .catch((err) => {
      });
  };

  const getData = async (pageData = 1) => {
    setLoading(true);

    let params = {
      stock_approve_status: statusSelected.value,
      page: pageData,
      stock_created_by_user_id: retail_permission.data?.type === 'staff' ? data_user.id : '',
      stock_type: typeSelected?.value,
      stock_from_store_id: storeFromSelected?.value,
      stock_to_store_id: storeToSelected?.value,
      stock_from_datetime: startDate !== '' ? moment(startDate).format('YYYY-MM-DD') + ' 00:00:00' : '',
      stock_until_datetime: endDate !== '' ? moment(endDate).format('YYYY-MM-DD') + ' 23:59:59' : '',
    }

    await Method.get(
      `company/${selected_company.value}/stock`,
      {
        params: params
      }
    )
      .then(async (res) => {
        if (res.data.success) {
          setData((state) => ({
            ...state,
            data: res.data.data,
            page: res.data.page,
            lastPage: res.data.last_page,
          }));
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          Component.AlertError({ title: "Error", text: error.response.data.error });
        } else {
          Component.AlertError({ title: "Error", text: 'Terjadi Kesalahan' });
        }
      });
  };

  const btnPagination = (e) => {
    getData(e.selected + 1)
  }

  const getDetailData = async (stock_id) => {
    await Method.get(`stock/${stock_id}`)
      .then(async (res) => {
        if (res.data.success) {
          setDetailData(res.data.data);
          setTimeout(() => {
            setModalForm('edit');
          }, 500)
        } else {
          Component.AlertError({ title: "Error", text: res.error });
        }
      })
      .catch((error) => {
        if (error.response) {
          Component.AlertError({ title: "Error", text: error.response.data.error });
        } else {
          Component.AlertError({ title: "Error", text: 'Terjadi Kesalahan' });
        }
      });
  }

  const btnMore = async (name, item) => {
    switch (name) {
      case "Lihat Detail":
        setRequestId(item.stock_id);
        setModalDetail(true);
        break;

      case "Ubah":
        getDetailData(item.stock_id);
        break;

      case "Approve":
        Component.AlertQuestion({
          title: "Warning",
          text: `Do you want to approve ${item.item.item_name}`,
        }).then((res) => {
          if (res.isConfirmed) {
            //action
            changeStatus(item.stock_id, 'approval')
          }
        });
        break;

      case "Reject":
        Component.AlertQuestion({
          title: "Warning",
          text: `Do you want to reject ${item.item.item_name}`,
        }).then((res) => {
          if (res.isConfirmed) {
            //action
            changeStatus(item.stock_id, 'reject')
          }
        });
        break;
      default:
        return name;
    }
  }

  const changeStatus = async (stock_id, status) => {
    setLoading(true);

    await Method.put(`stock/${stock_id}/${status}`, {})
      .then(async (res) => {
        if (res.data.success) {
          Component.AlertSuccess({ title: "Success", text: res.data.success });
          getData();
        } else {
          Component.AlertError({ title: "Error", text: res.data.error });
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          Component.AlertError({ title: "Error", text: error.response.data.error });
        } else {
          Component.AlertError({ title: "Error", text: 'Terjadi Kesalahan' });
        }
      });
  }

  useEffect(() => {
    GetCompany();
  }, []);

  useEffect(() => {
    getData();
  }, [retail_permission, statusSelected]);

  const filter = () => {
    getData();
  };

  const resetFilter = () => {
    setTypeSelected("");
    setStartDate("");
    setEndDate("");
    setStoreToSelected("")
    setStoreFromSelected("")
  };

  useEffect(() => {
    if (
      typeSelected === "" &&
      startDate === "" &&
      endDate === "" &&
      storeToSelected === "" &&
      storeFromSelected === ""
    ) {
      getData();
    }
  }, [typeSelected, startDate, endDate, storeToSelected, storeFromSelected]);

  return (
    <Style.ContainerContent>
      <Modal.ModalSelectCompany
        show={modal.company}
        onHide={() => setModal((state) => ({ ...state, company: false }))}
      />

      <Modal.ModalFormRequest
        show={modalForm}
        onHide={() => setModalForm(null)}
        onSubmit={() => {
          getData();
          setModalForm(null);
        }}
        data={detailData}
      />

      <Modal.ModalDetailRequest
        show={modalDetail}
        onHide={() => setModalDetail(false)}
        id={requestId}
      />

      <section>
        <div className="d-flex">
          <Style.HeaderPrimary color={Style.COLOR_PRIMARY}>
            Request Stock
          </Style.HeaderPrimary>
          <div className="wrap-select align-items-center ms-5">
            <button
              className="btn border"
              onClick={() => setModal((state) => ({ ...state, company: true }))}
            >
              {selected_company.label ? selected_company.label : "Select Company"}{" "}
              <i className="demo-icon icon-chevron-down"></i>
            </button>
          </div>
        </div>
      </section>

      <section className="mb-2">
        <Style.ButtonPrimary
          onClick={() => setModalForm('add')}
        >
          Manage Request Stock
        </Style.ButtonPrimary>
      </section>

      <section>
        <Component.Form>
          <div className="row">
             <div className="col-md-3 mb-2">
              <Style.Label color={Style.COLOR_SECONDARY}>Tipe</Style.Label>
              <Select
                placeholder="Pilihe Tipe"
                value={typeSelected}
                options={typeList}
                onChange={(e) => setTypeSelected(e)}
              />
            </div>
            <div className="col-md-3 mb-2">
              <Style.Label color={Style.COLOR_SECONDARY}>Dari Toko</Style.Label>
              <Select
                placeholder="Pilih Toko"
                options={storeFrom}
                onChange={(e) => {
                  setStoreFromSelected(e);
                }}
                onInputChange={(e) => {
                  setTimeout(async () => {
                    await Method.get(`company/${selected_company.value}/store?store_name=${e}&limit=*`)
                      .then(async (res) => {
                        if (res?.data?.success) {
                          setStoreFrom(
                            res?.data?.data?.map((item) => ({
                              value: item.store_id,
                              label: item.store_name
                            }))
                          )
                        }
                      })
                  }, 400)
                }}
                value={storeFromSelected}
              />
            </div>
            <div className="col-md-3 mb-2">
              <Style.Label color={Style.COLOR_SECONDARY}>Ke Toko</Style.Label>
              <Select
                placeholder="Pilih Toko"
                options={storeTo}
                onChange={(e) => {
                  setStoreToSelected(e);
                }}
                onInputChange={(e) => {
                  setTimeout(async () => {
                    await Method.get(`company/${selected_company.value}/store?store_name=${e}&limit=*`)
                      .then(async (res) => {
                        if (res?.data?.success) {
                          setStoreTo(
                            res?.data?.data?.map((item) => ({
                              value: item.store_id,
                              label: item.store_name
                            }))
                          )
                        }
                      })
                  }, 400)
                }}
                value={storeToSelected}
              />
            </div>
            <div className="col-md-3 mb-2">
              <Style.Label color={Style.COLOR_SECONDARY}>Tanggal Mulai</Style.Label>
              <Datepicker
                selected={startDate}
                className="form-control"
                onChange={(e) => setStartDate(e)}
                placeholderText="MM/DD/YYY"
              />
            </div>
            <div className="col-md-3 mb-2">
                <Style.Label color={Style.COLOR_SECONDARY}>Tanggal Berakhir</Style.Label>
                <Datepicker
                  selected={endDate}
                  className="form-control"
                  onChange={(e) => setEndDate(e)}
                  placeholderText="MM/DD/YYY"
                />
            </div>
            <div className="col-md-3 pt-4 pb-4 d-flex flex-row">
              <Style.ButtonPrimary onClick={() => filter()}>
                Cari
              </Style.ButtonPrimary>
              <button
                className="btn bg-light border border-gray ms-1"
                onClick={() => resetFilter()}
              >
                Reset
              </button>
            </div>
          </div>
          <hr/>
          <section className="d-flex flex-wrap justify-content-between align-items-end mb-3">
            <div className="col-md-2 mb-2">
              <Style.Label color={Style.COLOR_SECONDARY}>Status</Style.Label>
              <Select
                placeholder="Semua Status"
                value={statusSelected}
                options={statusList}
                onChange={(e) => setStatusSelected(e)}
              />
            </div>

            {selectedItems.length > 0 && statusSelected.label === "Pending" && (
              <div>
                <Style.ButtonPrimary
                  className="button is-success is-small"
                  onClick={async () => {
                    setLoading(true);

                    let successCount = 0;
                    let failCount = 0;

                    for (let item of selectedItems) {
                      try {
                        const res = await Method.put(`stock/${item.stock_id}/approval`, {});
                        if (res.data.success) {
                          successCount++;
                        } else {
                          failCount++;
                        }
                      } catch (error) {
                        failCount++;
                      }
                    }

                    setLoading(false);
                    setSelectedItems([]);
                    setSelectAll(false);
                    getData();

                    Component.AlertSuccess({
                      title: "Approve Result",
                      html: `
                        ✅ Success: ${successCount} item(s)<br/>
                        ❌ Failed: ${failCount} item(s)
                      `,
                    });
                  }}
                >
                  Approve Selected
                </Style.ButtonPrimary>
              </div>
            )}
          </section>
          <section className="mb-5 mb-md-5">
            <Component.TableData header={header}>
              {loading ? (
                <tr>
                  <td colSpan={header.length}>
                    <Component.Loadingfunc />
                  </td>
                </tr>
              ) : data.data.length === 0 ? (
                <tr>
                  <td colSpan={header.length} className="text-center">
                    <div>Data Tidak Ditemukan</div>
                  </td>
                </tr>
              ) : (
                data.data.map((item, index) => (
                  <tr
                    key={index}
                  >
                    {statusSelected.label === "Pending" ? (
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedItems.some((i) => i.stock_id === item.stock_id)}
                          onChange={() => handleCheck(item)}
                        />
                      </td>
                    ) : (
                      null
                    )}
                    <td data-label="No">{Numeric({ page: data.page, idx: index })}</td>
                    <td data-label="Produk">{item.item.item_name}</td>
                    <td data-label="Tipe">{item.stock_type}</td>
                    <td data-label="Dari">{item.from_store?.store_name}</td>
                    <td data-label="Ke">{item.to_store?.store_name}</td>
                    <td data-label="Qty">{item.stock_quantity}</td>
                    <td data-label="Tanggal">{moment(item.stock_date).format('DD-MMM-YYYY')}</td>
                    <td data-label="Foto">{ item.image ? <img src={item.image} alt="image" style={{width:100, height: 100, objectFit:"contain"}} /> : ''}</td>
                    <td data-label="Status">
                      {
                        <div
                          dangerouslySetInnerHTML={{
                            __html: displayStatus(
                              item.stock_approve_status_name
                            ),
                          }}
                        />
                      }
                    </td>
                    <td data-label="Aksi">
                      <Component.DropDown_More
                        title={
                          <div className="dropdown-trigger">
                            <button
                              className="button is-primary is-small"
                              aria-haspopup="true"
                              aria-controls="dropdown-menu"
                            >
                              <span className="icon is-small">•••</span>
                            </button>
                          </div>
                        }
                        data_more={data_more.filter((filter) =>
                          item.stock_approve_status_name === "pending"
                            ? retail_permission.data?.type === 'staff' ? filter.permission === 'staff' : filter
                            : filter.status === "all"
                        )}
                        onClick={({ name, id }) => btnMore(name, item)}
                      />
                    </td>
                  </tr>
                ))
              )}
            </Component.TableData>
          </section>

          {
            data.data.length > 0 &&
            <section>
              <Component.Pagination
                page={data.page}
                totalPage={data.lastPage}
                handleOnChange={(e) => btnPagination(e)}
              />
            </section>
          }
        </Component.Form>
      </section>
    </Style.ContainerContent>
  );
};
